const jwtServiceConfig = {
  signIn: 'auth/sign-in',
  signInWithGoogle: 'auth/google',
  signUp: 'auth/sign-up',
  signOut: 'auth/sign-out',
  accessToken: 'auth/access-token',
  updateUser: 'auth/user/update',
  getUser: '/auth/user',
  refreshToken: 'auth/refresh-token',
  nextHomeSignIn: 'auth/nexthome-sign-in',
  impersonateUser: 'auth/impersonate-user',
};

export default jwtServiceConfig;
